// extracted by mini-css-extract-plugin
export default {"container":"JobDetails_component_container__qbbtu","subContainer":"JobDetails_component_subContainer__tH7t4"};